import React from 'react';
import ChatMessageRow from './ChatMessageRow';
import ChatLinkPreviewList from './ChatLinkPreviewList';

export default function IndividualStandardMessageRow({
  message,
  variant = 'plain',
  preset,
  isSelf = false,
  senderName = '',
  senderContent = null,
  showSender = false,
  readCount = 0,
  readLabel = '既読',
  timeLabel = '',
  bubbleClassName = '',
  metaClassName = '',
  rowClassName = '',
  metaExtra = null,
  metaEndContent = null,
  avatarNode = null,
  activeAnchorMessageId = '',
  anchorClassName = 'is-anchor-hit',
  onContextMenu,
  onTouchStart,
  onTouchEnd,
  onTouchCancel,
  onTouchMove,
  sideActionContent = null,
  renderMessageContent,
  afterContent = null,
  footerContent = null,
}) {
  const linkPreviewCards = message?.linkPreview || message?.linkPreviews?.length
    ? <ChatLinkPreviewList message={message} />
    : null;
  const mergedFooter = (linkPreviewCards || footerContent)
    ? (<>{linkPreviewCards}{footerContent}</>)
    : null;
  return (
    <ChatMessageRow
      key={message?.id}
      variant={variant}
      preset={preset}
      isSelf={isSelf}
      messageId={message?.id}
      senderName={senderName}
      senderContent={senderContent}
      showSender={showSender}
      readCount={readCount}
      readLabel={readLabel}
      timeLabel={timeLabel}
      bubbleClassName={bubbleClassName}
      metaClassName={metaClassName}
      rowClassName={rowClassName}
      metaExtra={metaExtra}
      metaEndContent={metaEndContent}
      avatarNode={avatarNode}
      anchorActive={String(activeAnchorMessageId) === String(message?.id)}
      anchorClassName={anchorClassName}
      onContextMenu={onContextMenu}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      onTouchCancel={onTouchCancel}
      onTouchMove={onTouchMove}
      sideActionContent={sideActionContent}
      footerContent={mergedFooter}
    >
      {typeof renderMessageContent === 'function' ? renderMessageContent(message) : null}
      {afterContent}
    </ChatMessageRow>
  );
}
